import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export function wrapInitialData(WrappedComponent, loadInitialData) {
  return WrappedComponent.loadInitialData ? function (store, cookie, match, params) {
    return Promise.all([WrappedComponent.loadInitialData(store, cookie, match, params), loadInitialData(store, cookie, match, params)]);
  } : loadInitialData;
}